<template>
  <el-form
    class="users-form"
    ref="form"
    :rules="dynamicRules"
    :model="model"
    label-position="top"
    @submit.native.prevent="onSubmit"
  >
    <fieldset>
      <legend>Datos Generales</legend>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            label="Nombre"
            prop="firstName"
          >
            <el-input
              v-model="model.firstName"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Apellido Paterno"
            prop="lastName"
          >
            <el-input
              v-model="model.lastName"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Apellido Materno"
            prop="maidenName"
          >
            <el-input
              v-model="model.maidenName"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            label="Email"
            prop="email"
          >
            <el-input
              type="email"
              v-model="model.email"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Nombre de usuario"
            prop="username"
          >
            <el-input
              v-model="model.username"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Contraseña"
            prop="password"
          >
            <el-input
              type="password"
              v-model="model.password"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="Rol"
            prop="role"
          >
            <el-select
              v-model="model.role"
            >
              <el-option
                v-for="role of roles"
                :key="role.name"
                :value="role.name"
                :label="role.name | role"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </fieldset>

    <!--

    DATOS LABORALES

    -->
    <fieldset v-if="model.role === 'branch_chief' || model.role === 'dealer_chief' ">
      <legend>Datos Laborales</legend>
      <main>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="Distribuidor"
              :required="true"
              prop="dealerId"
            >
              <el-select
                v-model="model.dealerId"
                filterable
                @change="searchBranchesByDealer"
              >
                <el-option
                  v-for="dealer in dealers"
                  :key="dealer.id"
                  :value="dealer.id"
                  :label="dealer.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="model.role === 'branch_chief'"
              label="Sucursal"
              prop="branchId"
            >
              <el-select
                v-model="model.branchId"
                filterable
                :disabled="!model.dealerId"
                :loading="branches === null"
              >
                <el-option
                  v-for="branch in branches"
                  :key="branch.id"
                  :value="branch.id"
                >
                  {{ branch.municipality }}, {{ branch.state }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </main>
    </fieldset>

    <!--

    PERMISOS DE CONSULTA

    -->
    <fieldset v-if="model.role === 'pollster' || model.role === 'dealer'">
      <legend>Asignar permisos de consulta</legend>
      <main>
        <users-permissions-form
        v-model="permissions"/>
      </main>
    </fieldset>

    <fieldset v-if="model.role === 'pollster' || model.role === 'dealer'">
      <legend>Permisos de consulta</legend>
      <el-row>
        <el-col
          :span="24"
        >
          <table class="ms-grid">
            <thead>
              <tr>
                <th>Distribuidor</th>
                <th>Sucursal</th>
                <th>División</th>
                <th/>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(permission, $index) of permissions"
                :key="$index"
              >
                <td>
                  <span
                  v-if="permission.dealer">
                    {{ permission.dealer.name }}
                  </span>
                </td>
                <td>
                  <span
                  v-if="permission.branch">
                    {{ permission.branch.municipality }} {{ permission.branch.state }}
                  </span>
                </td>
                <td>{{ permission.division }}</td>
                <td>
                  <el-button @click="removePermission($index)"><i class="icon-trash"/></el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
    </fieldset>

    <el-row>
      <el-col>
        <el-button @click="onCancel">Cancelar</el-button>
        <el-button
          type="primary"
          native-type="submit"
        >Guardar
        </el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import User from './users.model'
import { mapActions } from 'vuex'
import roleFilter from '@/filters/role.filter'
import UsersPermissionsForm from './users-permissions-form'
import http from '@/services/http.service'

export default {
  name: 'UsersForm',
  components: {UsersPermissionsForm},
  filters: {
    role: roleFilter
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    old: {
      type: Object,
      default: null
    }
  },
  inject: ['dealers', 'roles', 'oldPermissions'],
  data () {
    return {
      model: User.model(this.user),
      rules: User.rules(),
      branches: [],
      permissions: []
    }
  },
  computed: {
    dynamicRules () {
      if (!this.isEdit) {
        return Object.assign(this.rules, User.rules(this.model))
      }
    }
  },
  mounted () {
    this.model = Object.assign({}, this.model, this.old)
    this.permissions = this.oldPermissions.slice(0)
  },
  methods: {
    ...mapActions('users', ['save', 'query']),
    removePermission (index) {
      console.log(typeof this.permissions)
      this.permissions.splice(index, 1)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.save(this.model).then(response => {
            if (response.data.role === 'pollster' || response.data.role === 'dealer') {
              let promises = []

              for (let permission of this.permissions) {
                permission.userId = response.data.id
                permission.userId = response.data.id
                permission.id = null
                promises.push(this.$store.dispatch('permissions/save', permission))
              }

              Promise.all(promises).then(() => {
                this.$message.success('El usuario se ha guardado con éxito')
                this.$router.push({name: 'users'})
              })
            } else {
              this.$message.success('El usuario se ha guardado con éxito')
              this.$router.push({name: 'users'})
            }
          }).catch(error => {
            console.error(error)
            this.$notify({
              title: 'Error al crear usuario.',
              message: 'Por favor, vuelve a intentarlo.'
            })
            return Promise.reject(error)
          })
        } else {
          this.$notify.error({
            title: 'Verifica la forma',
            message: 'Por favor, revisa lo errores que se indican dentro de la forma.'
          })
          return false
        }
      })
    },
    searchBranchesByDealer () {
      this.model.branchId = null
      this.branches = null
      alert('finding!')
      http.get('branches', {params: {'filters[where][dealerId][eq]': this.model.dealerId, limit: 1000}})
        .then(response => {
          this.branches = response.data.items
        })
    },
    onCancel () {
      this.$router.push({name: 'users'})
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
  .users-form {
    padding: 30px;
    margin: 30px;
    background-color: #fff;
  }

  .ms-grid {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/modules/users/users-form.vue